module.exports = __webpack_public_path__ + "3c24a72ecef8b1ed7ac24d26099cf793.svg";